<template>
  <div v-show="isShow" class="wh100 masking">
    <div class="dialog">
      <div class="dialog-left">
        <img class="xm-logo" src="./../assets/img/login-logo.png" alt="logo" />
      </div>
      <div class="dialog-right">
        <div class="w100 clearfix close-div">
          <div @click="isShow = false" class="close-box">
            <i class="iconfont close-icon">&#xe612;</i>
          </div>
        </div>
        <div class="header w100">{{ $t("register.title") }}</div>
        <div class="input-box password-box" ref="userRegister">
          <div class="icon-box flex-center">
            <img
              style="width: 2.4rem; height: 2.3rem"
              src="./../assets/img/tel-icon.png"
            />
          </div>
          <div class="input-centent">
            <input
              class="wh100"
              @focus="inputFoucs"
              @blur="checkUser"
              :placeholder="$t('register.input_phone')"
              type="tel"
              v-model="phoneNumber"
              maxlength="11"
            />
          </div>
        </div>
        <div class="warn" ref="warnTip">
          <i class="iconfont icon-warn">&#xe616;</i>&ensp;{{ userWarn }}
        </div>
        <div class="input-box no-margin" ref="checkRegister">
          <div class="icon-box flex-center">
            <img
              style="width: 2rem; height: 2.2rem"
              src="./../assets/img/code-icon.png"
            />
          </div>
          <div class="input-centent" style="display: flex">
            <input
              class="h100"
              style="width: 70%"
              :placeholder="$t('register.input_code')"
              @focus="checkFoucs"
              @blur="checkBlur"
              type="tel"
              v-model="checkCode"
              maxlength="8"
            />
            <div class="flex-center" style="width: 40%" @click="getCode">
              {{ codeBtn }}
            </div>
          </div>
        </div>
        <div class="warn" ref="checkWarn">
          <i class="iconfont icon-warn">&#xe616;</i>&ensp;{{
            $t("register.code_warn")
          }}
        </div>
        <div class="input-box no-margin" ref="passRegister">
          <div class="icon-box flex-center">
            <img
              style="width: 1.6rem; height: 1.8rem"
              src="./../assets/img/password.png"
            />
          </div>
          <div class="input-centent">
            <input
              class="wh100"
              @focus="passFoucs"
              @blur="passBlur"
              :placeholder="$t('register.input_password')"
              type="password"
              v-model="password"
            />
          </div>
        </div>
        <div class="warn" ref="passwordTip">
          <i class="iconfont icon-warn">&#xe616;</i>&ensp;{{
            $t("register.pass_warn")
          }}
        </div>
        <div class="w100 reminder">
          <span @click="goLogin">{{ $t("register.go_login") }}</span>
        </div>
        <div class="button" @click="registerBtn" ref="regiserBtn">
          <i class="iconfont loading-btn" v-show="loadingShow">&#xe63c;</i>
          {{ $t("register.register_and_login") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sign_rules from "../assets/js/sign_rules.js";
import { apiCheckUserExists } from "../http";
export default {
  components: {},
  data() {
    return {
      isShow: false,
      phoneNumber: "",
      checkCode: "",
      userCheckCode: "",
      password: "",
      codeBtn: this.$t("register.get_code"),
      timer: null,
      loadingShow: false,
      userWarn: "",
    };
  },
  watch: {
    "$i18n.locale"() {
      this.codeBtn = this.$t("register.get_code");
    },
  },
  methods: {
    getCode(e) {
      if (this.codeBtn === this.$t("register.get_code")) {
        let reg = /^1\d{10}$/;
        if (!reg.test(this.phoneNumber)) {
          this.$EventBus.$emit("hide", {
            msg: this.$t("register.phone_warn"),
            type: "error",
          });
        } else {
          let ele = e.target,
            timeScound = 60;
          ele.classList.add("alredy-send");
          this.codeBtn = this.$t("register.resend", { second: timeScound });
          this.timer = setInterval(() => {
            timeScound -= 1;
            this.codeBtn = this.$t("register.resend", { second: timeScound });
            if (timeScound <= 0) {
              ele.classList.remove("alredy-send");
              this.codeBtn = this.$t("register.get_code");
              clearInterval(this.timer);
            }
          }, 1000);

          let param = {
            mobile: this.phoneNumber,
          };
          let sign = this.md5(sign_rules(param));
          param.service = "PCLogin.GetCode";
          param.sign = sign;
          this.$axios.post("/", param).then((response) => {
            let res = response.data.data;
            if (res.code == 0) {
              this.$EventBus.$emit(
                "hide",
                this.$t("register.get_code_success")
              );
            } else {
              this.$EventBus.$emit("hide", { msg: res.msg, type: "error" });
              this.codeBtn = this.$t("register.get_code");
              ele.classList.remove("alredy-send");
              clearInterval(this.timer);
            }
          });
        }
      }
    },
    registerBtn() {
      let ele = this.$refs.regiserBtn;
      if (ele.classList.value.indexOf("register-btn") == -1) {
        let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/;
        if (this.phoneNumber.length < 11) {
          this.userWarn = this.$t("register.phone_warn");
          this.$refs.warnTip.style.visibility = "visible";
          return;
        } else if (this.checkCode.length < 4) {
          this.$refs.checkWarn.style.visibility = "visible";
          return;
        } else if (!reg.test(this.password)) {
          this.$refs.passwordTip.style.visibility = "visible";
          return;
        } else if (
          getComputedStyle(this.$refs.warnTip, null).visibility === "visible"
        ) {
          return;
        } else {
          ele.classList.add("register-btn");
          this.loadingShow = true;
          this.$axios
            .post("/", {
              user_login: this.phoneNumber,
              user_pass: this.password,
              service: "PCLogin.UserReg",
              code: this.checkCode,
              source: "pc",
            })
            .then((res) => {
              let data = res.data.data;
              if (data.code === 0) {
                localStorage.setItem("uid", data.info[0].id);
                localStorage.setItem("token", data.info[0].token);
                this.$store.commit("getUserInfo", data.info[0]);
                this.$emit("loginSuccess");
                this.$EventBus.$emit("hide", this.$t("register.login_success"));
                this.isShow = false;
              } else {
                this.$EventBus.$emit("hide", { msg: data.msg, type: "error" });
              }
            })
            .finally(() => {
              this.loadingShow = false;
              ele.classList.remove("register-btn");
            });
        }
      }
    },
    open() {
      this.isShow = true;
    },
    goLogin() {
      this.isShow = false;
      this.$emit("loginShow");
    },
    passFoucs() {
      this.$refs.passRegister.style.borderColor = "var(--primary-color)";
      this.$refs.passwordTip.style.visibility = "hidden";
    },
    passBlur() {
      this.$refs.passRegister.style.borderColor = "#D9D9D9";
      let reg = /^(?=.*\d)(?=.*[a-z])[a-zA-Z\d]{6,20}$/;
      if (!reg.test(this.password)) {
        this.$refs.passwordTip.style.visibility = "visible";
      }
    },
    checkFoucs() {
      this.$refs.checkRegister.style.borderColor = "var(--primary-color)";
      this.$refs.checkWarn.style.visibility = "hidden";
    },
    checkBlur() {
      this.$refs.checkRegister.style.borderColor = "#D9D9D9";
      if (this.checkCode.length < 4) {
        this.$refs.checkWarn.style.visibility = "visible";
      }
    },
    inputFoucs() {
      this.$refs.userRegister.style.borderColor = "var(--primary-color)";
      this.$refs.warnTip.style.visibility = "hidden";
    },
    checkUser() {
      this.$refs.userRegister.style.borderColor = "#D9D9D9";
      let reg = /^1\d{10}$/;
      if (!reg.test(this.phoneNumber)) {
        this.userWarn = this.$t("register.phone_warn");
        this.$refs.warnTip.style.visibility = "visible";
      } else {
        this.$axios
          .post("/", {
            service: "PCLogin.CheckUserExists",
            user_login: this.phoneNumber,
          })
          .then((response) => {
            let res = response.data.data;
            if (res.code == 0) {
              this.$refs.warnTip.style.visibility = "visible";
              this.userWarn = res.msg;
            }
          });
      }
    },
  },
};
</script>

<style scoped>
.masking {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.3);
}

.dialog {
  width: 90rem;
  min-height: 50rem;
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 3;
  margin-left: -45rem;
  margin-top: -28rem;
  background: #ffffff;
  border-radius: 0.5rem;
  box-shadow: 0.1rem 0.1rem 1.3rem 0rem rgba(0, 0, 0, 0.43);
  display: flex;
  overflow: hidden;
}

.close-box {
  position: absolute;
  cursor: pointer;
  float: right;
  top: 1.8rem;
  right: 1.8rem;
}

.header {
  width: 32rem;
  height: 3.9rem;
  line-height: 3.9rem;
  font-size: 1.4rem;
  font-family: Microsoft YaHei;
  color: #39404d;
  text-align: center;
  background: linear-gradient(90deg, #ffc316 4.33%, #fbcb70 122.33%);
  border-radius: 20px;
  margin-top: 8rem;
}

.input-box {
  width: 32rem;
  height: 3.2rem;
  background: #fff;
  margin-top: 3rem;
  display: flex;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  overflow: hidden;
}

.icon-box {
  width: 5.2rem;
  height: 3.2rem;
  background: rgba(236, 233, 233, 0.77);
  border-right: 1px solid #d9d9d9;
  border-radius: 5px 0px 0px 5px;
}

.input-centent {
  width: calc(100% - 4rem);
  height: 100%;
}
.input-centent input {
  padding-left: 1rem;
}

.input-centent > div {
  font-family: Microsoft YaHei;
  color: #ffffff;
  cursor: pointer;
  background: #eeb308;
}
.input-centent > .alredy-send {
  color: #8e8e93;
  background: #c7c7cc;
}
.reminder {
  width: 32rem;
  font-size: 1.4rem;
  font-family: Microsoft YaHei;
  color: #b78b0e;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

.button {
  width: 32rem;
  height: 4rem;
  line-height: 4rem;
  background: linear-gradient(90deg, #fbdd7f 0%, #fbca6f 98.96%);
  border-radius: 5px;
  text-align: center;
  margin-top: 1.6rem;
  margin-bottom: 1.6rem;
  font-size: 1.4rem;
  font-family: Microsoft YaHei;
  color: #39404d;
  cursor: pointer;
}
.register-btn {
  opacity: 0.5;
}
.no-margin {
  margin-top: 0;
}
.dialog-right {
  width: 43.3rem;
  padding-left: 5rem;
}
.dialog-left {
  width: 44.7rem;
  background: url("../assets/img/login-bg.png");
  background-size: 100% 100%;
  color: #fff;
  font-size: 1.4rem;
  text-align: center;
  position: relative;
  left: 0;
  z-index: 1;
}
.download-app {
  margin-top: 3.4rem;
}
.more-game {
  margin-top: 0.6rem;
}
.erweima {
  margin-top: 2.5rem;
  width: 12rem;
  height: 12rem;
}
.system {
  margin-top: 2.5rem;
  font-size: 1.2rem;
}
.xm-logo {
  position: absolute;
  top: 3.2rem;
  left: 2.6rem;
}
.warn {
  margin-left: 4rem;
  line-height: 2.4rem;
  height: 2.8rem;
  color: #fa0505;
  font-size: 1.2rem;
  visibility: hidden;
}
.icon-warn {
  font-size: 1.4rem;
}
.close-div {
  position: relative;
  height: 2rem;
}
.close-icon {
  color: #94979e;
  font-size: 1.2rem;
}
.password-box {
  margin-top: 2.5rem;
}
.passwordwarn {
  visibility: visible;
  height: 2.4rem;
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/base/register.vue